// removed by extract-text-webpack-plugin
module.exports = {"skeleton":"styles__skeleton___1bJjU","skeleton-loading":"styles__skeleton-loading___2t5de","whiteBackgroundSkeleton":"styles__whiteBackgroundSkeleton___HggTb","mainSectionSkeleton":"styles__mainSectionSkeleton___1SrXE","skeletonText":"styles__skeletonText___rxsnR","skeletonDescription":"styles__skeletonDescription___9G3wD","skeletonButton":"styles__skeletonButton___2iKeI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Skeleton/NoScheduleOnlineInterfaceSkeleton/styles.css
// module id = 2527
// module chunks = 0